import { AuthAPI } from "../../api/auth";

export async function autoDirect() {
  const res = await AuthAPI.check();
  // const currentPath = window.location.pathname;
  if (res && res.id) {
    window.location.href = "/vips/mainpage";
  }
  // else {
  //   window.location.href = currentPath;
  // }
}

export async function restore() {
  const res = await AuthAPI.check();
  const currentPath = window.location.pathname;
  if (res && res.id) {
    window.location.href = currentPath;
  } else {
    window.location.href = "/vips/login";
  }
}
